import React from 'react'
import styled, { keyframes } from 'styled-components'
import { useIntl } from 'gatsby-plugin-intl'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import StarIcon from '@material-ui/icons/Star'

const FavoriteOfferButton = ({ active = false, className, onClick }) => {
  const intl = useIntl()
  const label = intl.formatMessage({
    id: active ? 'offers.removeFromFavorites' : 'offers.addToFavorites'
  })

  return (
    <button
      type='button'
      className={className}
      aria-label={label}
      aria-pressed={active}
      title={label}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
        onClick()
      }}
    >
      {active ? <FilledStar /> : <StarBorderIcon />}
    </button>
  )
}

const favoritePop = keyframes`
  0% { transform: scale(0.7) rotate(-18deg); }
  65% { transform: scale(1.2) rotate(8deg); }
  100% { transform: scale(1) rotate(0); }
`

const FilledStar = styled(StarIcon)`
  animation: ${favoritePop} 0.3s ease-out;
`

export default styled(FavoriteOfferButton)`
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.corduroy.alpha(0.55).hex()};
  cursor: pointer;
  transition: color 0.16s ease, transform 0.16s ease;

  &[aria-pressed='true'] {
    color: #f4b400;
  }

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.corduroy.hex()};
  }

  &[aria-pressed='true']:hover,
  &[aria-pressed='true']:focus-visible {
    color: #e5a500;
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }) => theme.colors.easternBlue.alpha(0.3).hex()};
    outline-offset: 1px;
  }

  svg {
    width: 19px;
    height: 19px;
  }
`
